import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import Login from '../components/Login';
import {AUTH_TOKEN_STORAGE_KEY} from '../constants/storageConstants';

const LOGIN_MUTATION = gql`
  mutation login($loginToken: String!, $loginName: String!) {
    login(loginToken: $loginToken, loginName: $loginName)
  }
`;

const LOGIN_MUTATION_CONFIG = {
  props: ({mutate}) => ({
    login(variables) {
      return mutate({
        variables,
        update: (_, {data: {login: token}}) => localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token),
      });
    },
  }),
};

export default graphql(LOGIN_MUTATION, LOGIN_MUTATION_CONFIG)(Login);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js